import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DonationForm from "../common/donation-form";
import { ResourceTypes } from "../../constants/enums";
import { Styles } from "./styles";

const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=800&q=80";
const DEFAULT_TITLE_KEY = "You will make a difference";
const DEFAULT_DESCRIPTION_KEY =
  "Vital support is out of reach for many. Donate today to help protect and empower more people in need.";

const DonateModal = ({
  isOpen,
  onClose,
  resolvedType = ResourceTypes.PLATFORM,
  id,
  image = DEFAULT_IMAGE,
  title,
  description,
}) => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";
  const [status, setStatus] = useState({ type: "idle", message: "" });

  if (!isOpen) return null;

  const displayTitle = title ?? t(DEFAULT_TITLE_KEY);
  const displayDescription = description ?? t(DEFAULT_DESCRIPTION_KEY);

  const handleClose = () => {
    setStatus({ type: "idle", message: "" });
    onClose?.();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) handleClose();
  };

  return (
    <Styles $isAr={isAr} className="donate-modal">
      <div className="donate-modal-overlay" onClick={handleOverlayClick}>
        <div className="donate-modal-box-wrap">
          <div className="donate-modal-box">
            <section className="donate-modal-section-content">
              <div className="donate-modal-image-wrap">
                <img
                  src={image}
                  alt=""
                  className="donate-modal-image"
                />
              </div>
              <h2 className="donate-modal-title">{displayTitle}</h2>
              <p className="donate-modal-description">{displayDescription}</p>
            </section>
            <section className="donate-modal-section-form">
              <DonationForm
                resolvedType={resolvedType}
                id={id}
                onStatusChange={setStatus}
                instanceId="modal"
              />
              {status.message && (
                <div
                  className={`alert ${status.type === "success" ? "alert-success" : "alert-danger"} mt-3 mb-0`}
                  role="alert"
                >
                  {status.message}
                </div>
              )}
            </section>
          </div>
        </div>
      </div>
    </Styles>
  );
};

export default DonateModal;
